import { CHAR_SYMBOL } from './CHAR_SYMBOL';

export const IGNORED_NUMBER_SYMBOLS = [
    CHAR_SYMBOL.EXP,
    CHAR_SYMBOL.PLUS,
    CHAR_SYMBOL.MINUS,
];
